import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { RatingsDataService, RatingsColumnsService } from '../../../services';
import { Rating, RatingsResult } from '../../../interfaces';

@Component({
  selector: 'app-rating-form',
  templateUrl: './rating-form.component.html',
  styleUrls: ['./rating-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class RatingFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public rating: Rating = {};
  public ratingForm: FormGroup = new FormGroup({});
  public ratings: Rating[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;


  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private ratingsDataService: RatingsDataService,
    public ratingsColumnsService: RatingsColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'RatingFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Rating - Edit');
        this.getRating(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.rating !== 'undefined') {
      this.rating = this.dynamicDialogConfig.data.rating;
    }
    if (typeof this.rating.id === 'undefined' || this.rating.id === null) {
      this.rating.id = null;
    }
    this.getRatings();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'RatingFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'RatingFormComponent');
  }

  getRating(id: number): void {
    this.isLoading = true;
    this.ratingsDataService.getRating(id).subscribe((response: Rating|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.rating = response;
        this.prepareFrom();
      }
    });
  }

  getRatings(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.ratings !== 'undefined' && this.dynamicDialogConfig.data.ratings.length > 0) {
      this.ratings = this.dynamicDialogConfig.data.ratings;
      return;
    }
    this.ratingsDataService.getRatings(this.parameters).subscribe((response: RatingsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.ratings = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.ratingForm = new FormGroup({
      id: new FormControl(this.rating.id, []),
      entity: new FormControl(this.rating.entity, [Validators.required, ]),
      foreignKey: new FormControl(this.rating.foreignKey, [Validators.required, ]),
      value: new FormControl(this.rating.value, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/ratings']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.ratingForm.controls).forEach((field: any) => {
        const control = this.ratingForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.ratingForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.rating = this.ratingForm.value;
    this.disableSubmit = true;
    console.log('rating', this.rating);
    if (typeof this.rating.id !== 'undefined' && this.rating.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.ratingsDataService.updateRating(this.rating).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('RATINGUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('RATINGNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.ratingsDataService.addRating(this.rating).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('RATINGCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('RATINGNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

}

@Component({
  selector: 'app-rating-form',
  templateUrl: './rating-form.component.html',
  styleUrls: ['./rating-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogRatingFormComponent extends RatingFormComponent {
}

